<script lang="ts" setup>
import { getDashboardUrl } from '@/app/core/services/dashboard'
import { onMounted, ref } from 'vue'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
usePayrollChange(() => window.location.reload())

const metabaseUrl = ref('')

onMounted(async () => {
  metabaseUrl.value = await getDashboardUrl()
})
</script>
<template>
  <div class="w-full h-full p-5 pt-24 overflow-auto scroll">
    <iframe :src="metabaseUrl" title="Dashboard" class="w-full h-full"></iframe>
  </div>
</template>
